const initialState = {
  message: '',
  variant: '',
};

function user(state = initialState, action) {
  switch (action.type) {
    case 'SET_ERROR_500':
      return { ...state, message: action.error, variant: 'error' };
    case 'SET_ERROR_403':
      return { ...state, message: action.error, variant: 'error' };
    case 'SET_NOTIFICATION':
      return { ...state, message: action.message, variant: 'info' };
    case 'CLEAR_ERROR_MESSAGE':
      return { ...state, message: action.error, variant: 'error' };
    default:
      return state;
  }
}

export default user;
